import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  id?: string;
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  id
}: FadeInProps) {
  return <motion.div id={id} initial={{
    opacity: 0,
    y: 6
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-10px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-29">
      {children}
    </motion.div>;
}